module.exports = __webpack_public_path__ + "img/pic_bank.9d4d3b2a.png";